import { BrokerActionType } from '../Constants';
import store, { brokerActions } from '@apply/adminStore';
import { LoginApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';

export const executeBrokerAction = async (itemData: { actionId: number; brokerId: number; userId: string }) => {
    const { dispatch } = store;
    const loginApi = new LoginApi.LoginApi(applicationInsights);

    const onViewEditBroker = (brokerId: number) => {
        dispatch(brokerActions.setBrokerId({ brokerId: brokerId }));
        dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: true }));
        return true;
    };

    const onSendPasswordResetEmail = async (userId: string) => {
        const response = await loginApi.forgotPasswordByUserId(userId);
        return response.statusCode === 200;
    };

    const onDeleteIncompleteRegisteredBroker = (userId: string) => {
        dispatch(
            brokerActions.setDeleteIncompleteRegisteredBrokerModal({
                deleteIncompleteRegisteredBrokerModal: { isOpen: true, userId },
            })
        );
    };

    const onNotImplemented = () => {
        alert('Not Implemented!');
        return false;
    };

    switch (itemData.actionId) {
        case BrokerActionType.ViewEditBroker:
            return onViewEditBroker(itemData.brokerId);
        case BrokerActionType.DeleteIncompleteRegisteredBroker:
            return onDeleteIncompleteRegisteredBroker(itemData.userId);
        case BrokerActionType.SendPasswordResetEmail:
            return await onSendPasswordResetEmail(itemData.userId);
        default:
            return onNotImplemented();
    }
};
